<form>
  <!-- Top filter -->
  <div class="row m-4">
    <div class="form-group col-md-1">
      <label class="control-label fw-bold">Please&nbsp;select:</label>
    </div>

    <div class="form-group col-md-3">
      <label for="templateProductLineSelection" class="control-label fw-bold">Product Line:</label>
      <select id="templateProductLineSelection" name="templateProductLineSelection" class="form-control"
              [(ngModel)]="templateProductLineSel"
              (change)="selectDefaultTemplateByProductLineSel(); filterVariablesByProductLineSel(); resetProgramSel(); loadTemplateData()">
        <option *ngFor="let templateProductLine of templateProductLines"
                [ngValue]="templateProductLine">{{templateProductLine.code}}</option>
      </select>
    </div>

    <div class="form-group col-md-3">
      <label for="localeSelection" class="control-label fw-bold">Locale:</label>
      <select id="localeSelection" name="localeSelection" class="form-control"
              [(ngModel)]="localeSel" (change)="loadTemplateData()">
        <option *ngFor="let locale of locales"
                [ngValue]="locale">{{locale.displayLabels.en_US}}</option>
      </select>
    </div>

    <div class="form-group col-md-4" *ngIf="templateProductLineSel && templateProductLineSel.code !== productLineEnum.ENERGY_MANAGEMENT_SYSTEMS">
      <label for="programSelection" class="control-label fw-bold">Operator - Program - Product:</label>
      <select id="programSelection" name="programSelection" class="form-control"
              [(ngModel)]="productSel" (change)="loadTemplateData()">
        <option *ngFor="let product of products"
                [ngValue]="product">{{getOperatorProgramProductDisplayLabel(product)}}</option>
      </select>
    </div>
  </div>

  <div class="form-group col-md-12">
    <hr class="border border-dark ms-4"/>
  </div>
  <!-- END Top filter -->
<div class="row">
  <!-- Left Panel -->
  <div class="col-md-6 vl">
    <!-- Left filter -->
    <div class="row m-4">
      <div class="form-group col-md-2">
        <label class="control-label fw-bold">Please&nbsp;select:</label>
      </div>

      <div class="form-group col-md-6">
        <label for="templateSelection" class="control-label fw-bold">Template:</label>
        <select id="templateSelection" name="templateSelection" class="form-control" [(ngModel)]="templateSel"
                (change)="loadTemplateData()">
          <option *ngFor="let template of templates | templatesByComponentType: templateProductLineSel"
                  [ngValue]="template">{{template.displayLabel}}</option>
        </select>
      </div>

      <div class="form-group col-md-3">
        <label for="templateDeliveryPathSelection" class="control-label fw-bold">Delivery Path:</label>
        <select id="templateDeliveryPathSelection" name="templateDeliveryPathSelection" class="form-control"
                [(ngModel)]="templateDeliveryPathSel" (change)="loadTemplateData();">
          <option *ngFor="let templateDeliveryPath of templateDeliveryPaths"
                  [ngValue]="templateDeliveryPath">{{templateDeliveryPath.code}}</option>
        </select>
      </div>

      <div class="form-group col-md-1" style="float: right">
        <br>
        <button *ngIf="templateWithContent.definitions.length > 0"
                id="previewTemplate"
                type="button"
                class="btn btn-primary fa fa-eye fa-lg"
                style="float: right; margin-top: 5px;"
                tooltip="Template preview"
                data-bs-target="#previewModal"
                [disabled]="loadingTemplateContents"
                (click)="resetTemplatePreviewShowPilcrow(); getPreviewTemplateText(); previewModal.show()">
        </button>
      </div>
    </div>
    <!-- END Left filter -->
    <div class="row ms-4 me-1">
      <!--   Loading Contents Message   -->
      <div class="col-md-12" id="loadingTemplateContentsMessage" *ngIf="loadingTemplateContents">
        <p class="round-border bg-enelx-light-purple padding-md"  style="color: #461E7D;">
          <i class="fa fa-spinner fa-spin fa-lg"></i>
          <strong>&nbsp; Loading contents, please, wait...</strong>
        </p>
      </div>
      <!--   END Loading Contents Message   -->
      <!--   No Contents Message Loaded  -->
      <div class="col-md-12" id="failedContentsLoadMessage"
           *ngIf="templateWithContent.definitions.length === 0 && !loadingTemplateContents">
        <p class="round-border bg-warning padding-md" style="font-size: medium">
          <i class="fas fa-exclamation-triangle" style="color: #FF9900"></i>&nbsp;
          <strong>{{failedContentsLoadMessage}}</strong></p>
      </div>
      <!--   END No Contents Message Loaded  -->
      <!--   Voice locale INFO  -->
      <div *ngIf="templateWithContent.definitions.length > 0 && !loadingTemplateContents &&
           templateDeliveryPathSel?.code === deliveryPathEnum.VOICE && !isLoadingLocaleVoiceInfo">
        <div class="col-md-12" id="differentLocaleForVoiceContentsInfoMessage"
             *ngIf="ttsAppDefaults?.defVoice?.voice &&
             localeSel?.localeName?.replace('_','-') !== ttsAppDefaults?.defVoice?.voice?.languageCode">
          <p class="round-border bg-enelx-light-purple padding-md"  style="color: #461E7D;">
            <i class="fas fa-lg fa-info-circle"></i>&nbsp;
            <strong>Please, write the contents for voice in '{{ttsAppDefaults?.defVoice?.voice?.languageName}}'
              ({{ttsAppDefaults?.defVoice?.voice?.languageCode}})</strong></p>
        </div>
        <div class="col-md-12" id="noLocaleForVoiceContentsWarningMessage"
             *ngIf="!ttsAppDefaults?.defVoice?.voice">
          <p class="round-border bg-warning padding-md" style="font-size: medium">
            <i class="fas fa-exclamation-triangle" style="color: #FF9900"></i>&nbsp;
            <strong>There is no available voice to convert text to speech for the current
              locale: {{localeSel?.displayLabels?.en_US}}.</strong></p>
        </div>
      </div>
      <!--   END Voice locale INFO  -->
      <!-- considerations box -->
      <div class="col-md-12" *ngIf="templateWithContent.definitions.length > 0 && !loadingTemplateContents &&
        (templateDeliveryPathSel?.code === deliveryPathEnum.EMAIL || templateDeliveryPathSel?.code === deliveryPathEnum.SMS)">
        <div class="round-border bg-enelx-light-purple padding-md" style="color: #461E7D; font-size: small; margin: 0 0 10px;">
          <i class="fas fa-lg fa-info-circle"></i>&nbsp;
          <strong>Considerations:</strong>
          <!-- EMAIL -->
          <span *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.EMAIL">
            <p class="round-border bg-enelx-light-purple padding-xs">Subject and body need to be populated</p>
            <p class="round-border bg-enelx-light-purple padding-xs">Subject may be truncated if count of characters is over 255 after replacing variables</p>
            <p class="round-border bg-enelx-light-purple padding-xs">Total characters supported including body and subject is 2500 after replacing variables, if message exceeds this value the notification may not be sent</p>
          </span>
          <!-- SMS -->
          <span *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.SMS">
            <p class="round-border bg-enelx-light-purple padding-xs">Subject and body need to be populated</p>
          </span>
        </div>
      </div>
      <!-- Email considerations box -->
      <!--   Components Panel  -->
      <div class="col-md-12" *ngIf="templateWithContent.definitions.length > 0 && !loadingTemplateContents">
        <!--   SUBJECT Panels  -->
        <div class="card mb-2" *ngFor="let templateDefinition of templateWithContent.definitions | componentTypeFilter:componentTypeEnum.SUBJECT">
          <div class="card-header">
            <span style="margin-right: 10px" *ngIf="isCustomizedContent(templateDefinition.templateComponent)">
              <i [id]="'customizedContent_' + templateDefinition.displaySequence" class="fa fa-globe fa-lg"
                 tooltip="Customized content for selected locale and product" containerClass="tooltip-container-xs"></i>
            </span>
            {{templateDefinition.templateComponent ? templateDefinition.templateComponent.displayLabel : ''}}

            <span style="margin-left: 10px" *ngIf="getSharedComponentTemplatesCount(templateDefinition.templateComponent) > 1 ">
              <i [id]="'multipleUsages_' + templateDefinition.displaySequence" class="fas fa-project-diagram"
                 [tooltip]="'Shared across ' + getSharedComponentTemplatesCount(templateDefinition.templateComponent) + ' templates'" containerClass="tooltip-container-xs"></i>
            </span>
            <span style="float: right" *ngIf="isCustomizableContent()">
              <a [id]="'revertDefaultContent_' + templateDefinition.displaySequence"
                 *ngIf="isCustomizedContent(templateDefinition.templateComponent)"
                 (click)="showConfirmRevertToDefaultContent( templateDefinition )"
                 class="fa fa-undo fa-lg"
                 style="margin-right: 12px"
                 tooltip="Revert to default content"
                 container="body"></a>
              <a [id]="'customizeContent_' + templateDefinition.displaySequence"
                 (click)="customizingContentEditorExpanded( templateDefinition )"
                 [attr.aria-expanded]="true"
                 [attr.aria-controls]="'customizingContent_' + templateDefinition.displaySequence"
                 class="fa fa-edit fa-lg" tooltip="Customize content"
                 container="body"></a>
            </span>
          </div>
          <div class="card-body template-content">
            <div class="row row-vertical-align card-text">
              <div [className]="templateDeliveryPathSel?.code === deliveryPathEnum.VOICE ? 'col-md-11' : 'col-md-12'">
                <span [id]="'compContent_' + templateDefinition.displaySequence"
                      [innerHTML]="getContentText(templateDefinition.templateComponent)">
                </span>
              </div>
              <div class="col-md-1" *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.VOICE">
                <app-content-player [id]="'compContentPlayer_' + templateDefinition.displaySequence"
                                    [for]="'compContent_' + templateDefinition.displaySequence" controls="Pl"
                                    [text]="getContentText(templateDefinition.templateComponent)"
                                    [locale]="getContent(templateDefinition).locale"></app-content-player>
              </div>
            </div>
          </div>
        </div>
        <!--   END SUBJECT Panels  -->
        <!--   BODY Panels  -->
        <div class="card mb-2" *ngFor="let templateDefinition of templateWithContent.definitions | componentTypeFilter:componentTypeEnum.BODY">
          <div class="card-header">
            <span class="mr-10" *ngIf="isCustomizedContent(templateDefinition.templateComponent)">
              <i [id]="'customizedContent_' + templateDefinition.displaySequence" class="fa fa-globe fa-lg"
                 tooltip="Customized content for selected locale and product" containerClass="tooltip-container-xs"></i>
            </span>
            {{templateDefinition.templateComponent ? templateDefinition.templateComponent.displayLabel : ''}}

            <span class="right" *ngIf="isCustomizableContent()">
              <a [id]="'revertDefaultContent_' + templateDefinition.displaySequence"
                 *ngIf="isCustomizedContent(templateDefinition.templateComponent)"
                 (click)="showConfirmRevertToDefaultContent( templateDefinition )"
                 class="fa fa-undo fa-lg"
                 style="margin-right: 12px"
                 tooltip="Revert to default content"
                 container="body"></a>
              <a [id]="'customizeContent_' + templateDefinition.displaySequence"
                 (click)="customizingContentEditorExpanded( templateDefinition )"
                 [attr.aria-expanded]="true"
                 [attr.aria-controls]="'customizingContent_' + templateDefinition.displaySequence"
                 class="fa fa-edit fa-lg" tooltip="Customize content"
                 container="body"></a>
            </span>
            <span class="right mr-20 shared" *ngIf="getTemplatesRelatedToCount(templateDefinition.templateComponent) > 1">
              Shared across <button type="button" class="btn btn-primary" class="reverse" (click)="onSharedTemplatesSelected(templateDefinition.templateComponent)">{{getTemplatesRelatedToCount(templateDefinition.templateComponent) == templates.length ? 'all' : getTemplatesRelatedToCount(templateDefinition.templateComponent)}} templates</button>
            </span>
          </div>
          <div class="card-body template-content">
            <div class="row row-vertical-align">
              <div [className]="templateDeliveryPathSel?.code === deliveryPathEnum.VOICE ? 'col-md-11' : 'col-md-12'">
                <span [id]="'compContent_' + templateDefinition.displaySequence"
                      [innerHTML]="templateDeliveryPathSel?.code === deliveryPathEnum.VOICE ? getContentText(templateDefinition.templateComponent, { escapeSSMLTags: true }) : getContentText(templateDefinition.templateComponent)">
                </span>
              </div>
              <div class="col-md-1" *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.VOICE">
                <app-content-player [id]="'compContentPlayer_' + templateDefinition.displaySequence"
                                    [for]="'compContent_' + templateDefinition.displaySequence" controls="Pl"
                                    [text]="getContentText(templateDefinition.templateComponent)"
                                    [locale]="getContent(templateDefinition).locale"></app-content-player>
              </div>
            </div>
          </div>
        </div>
        <!--   END BODY Panels  -->

      </div>
      <!--   END Components Panel  -->
    </div>
  </div>
  <!-- END Left Panel -->

  <!-- Right Panel -->
  <div class="col-md-6" *ngIf="shouldOpenRightPanel()">
    <!-- Customizing Content Editor -->
    <div [id]="'customizingContent_' + templateDefinitionSel.displaySequence"
         [collapse]="false"
         class="card collapse fade">
      <div class="card-header">
        Customizing content for {{templateDefinitionSel.templateComponent.displayLabel}} in {{localeSel.displayLabels.en_US}}
      </div>

      <div class="card-body">
        <div class="form-group">
          <label [for]="'customizingContentEditorText_' + templateDefinitionSel.displaySequence" class="control-label fw-bold">Content:</label>
          <div *ngIf="templateDeliveryPathSel.code === deliveryPathEnum.EMAIL && templateDefinitionSel.templateComponent.componentType !== componentTypeEnum.SUBJECT">
            <form [formGroup]="editorForm">
              <div class="NgxEditor__Wrapper editor">
                <ngx-editor-menu [editor]="editor" [toolbar]="editorToolbar"></ngx-editor-menu>
                <ngx-editor
                  [placeholder]=""
                  (drop)="dropVariable($event)"
                  (dragover)="allowDropVariable($event)"
                  [uiId]="'uiRichEditor_' + templateDefinitionSel.displaySequence"
                  [name]="'customizingContentEditorText_' + templateDefinitionSel.displaySequence"
                  [id]="'customizingContentEditorText_' + templateDefinitionSel.displaySequence"
                  [editor]="editor"
                  formControlName="customizingContent"></ngx-editor>
              </div>
            </form>
          </div>
          <div *ngIf="templateDeliveryPathSel.code === deliveryPathEnum.SMS ||
                      (templateDeliveryPathSel.code === deliveryPathEnum.EMAIL &&
                      templateDefinitionSel.templateComponent.componentType === componentTypeEnum.SUBJECT) || templateDeliveryPathSel.code === deliveryPathEnum.PUSH"
               contenteditable="true">
            <textarea rows="2"
                      style="white-space: pre-wrap;"
                      (keyup)="checkSubjectLen()"
                      (click)="checkSubjectLen()"
                      (drop)="dropVariable($event)"
                      (dragover)="allowDropVariable($event)"
                      class="form-control"
                      [id]="'customizingContentEditorText_' + templateDefinitionSel.displaySequence"
                      [name]="'customizingContentEditorText_' + templateDefinitionSel.displaySequence"
                      [(ngModel)]="customizingContentEditorText"
                      autofocus>
            </textarea>
          </div>
          <div *ngIf="templateDeliveryPathSel.code === deliveryPathEnum.VOICE" contenteditable="true" mwlTextInputHighlightContainer>
            <textarea rows="2"
                      style="white-space: pre-wrap;"
                      (keyup)="checkSubjectLen()"
                      (click)="checkSubjectLen()"
                      (drop)="dropVariable($event)"
                      (dragover)="allowDropVariable($event)"
                      class="form-control"
                      [id]="'customizingContentEditorText_' + templateDefinitionSel.displaySequence"
                      [name]="'customizingContentEditorText_' + templateDefinitionSel.displaySequence"
                      [(ngModel)]="customizingContentEditorText"
                      mwlTextInputElement
                      #customizingContentEditor
                      (input)="validateSsmlTags()"
                      autofocus>
            </textarea>
            <mwl-text-input-highlight [tags]="invalidSsmlTags"
                                      [textInputElement]="customizingContentEditor">
            </mwl-text-input-highlight>
          </div>
<!--          <div [className]="'row' + (templateDeliveryPathSel.code === deliveryPathEnum.EMAIL  && templateDefinition.templateComponent.componentType !== componentTypeEnum.SUBJECT? ' fate-edit-target-custom-fix' : '')">-->
          <div class="row">
            <div class="col-md-8">
              <span [id]="'customizingContentEditorTextCount_' + templateDefinitionSel.displaySequence" class="form-control-static text-body-secondary">Character count: <span class="badge">{{customizingContentEditorText.length}}</span></span>
            </div>
            <div class="col-md-4 text-right" *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.VOICE">
              <span class="control-label fw-bold">AWS SSML Tags Supported <a href="https://docs.aws.amazon.com/polly/latest/dg/supportedtags.html" target="_blank" class="fas fa-external-link-alt"></a></span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <span *ngIf="stripHtmlTags(this.customizingContentEditorText) !== stripHtmlTags(this.customizingContentEditorTextOriginal) && isTextEmpty()" class="form-control-static text-body-secondary text-danger">Subject or body can not be empty or include only spaces, tabs or newline characters.</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label [for]="'customizingContentEditorVariables_' + templateDefinitionSel.displaySequence" class="control-label fw-bold">Place your cursor where you want the variable to end up in the text and then drag and drop the variable in the editor</label>
          <div [id]="'customizingContentEditorVariables_' + templateDefinitionSel.displaySequence"  class="form-control" style="height: 250px;overflow-y: auto;">
            <table>
              <tr *ngFor="let templateComponentVariable of templateComponentVariables">
                <td class="col-md-6 vl">
                  <span draggable="true"
                        (dragstart)="dragVariable($event, 'customizingContentEditorText_' + templateDefinitionSel.displaySequence)"
                        (dblclick)="doubleClickVariable($event, 'customizingContentEditorText_' + templateDefinitionSel.displaySequence)"
                        [tooltip]="templateComponentVariable.displayLabel"
                        [innerHTML]="'\{\{\{' + templateComponentVariable.displayLabel + '\}\}\}'">
                  </span>
                </td>
                <td class="col-md-6">
                  <span [tooltip]="templateComponentVariable.displayLabel">{{templateComponentVariable.sampleContentHtml}}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button [id]="'cancelCustomizingContent_' + templateDefinitionSel.displaySequence" class="col-md-3 col-md-offset-6 text-right btn btn-default btn-sm" type="button" [disabled]="!isCustomizingContentEditorTextChanged()" (click)="discardCustomizingContentModal.show()">Cancel</button>
            <button [id]="'saveCustomizingContent_' + templateDefinitionSel.displaySequence" class="col-md-3 col-md-offset-6 text-right btn btn-primary btn-sm" type="button" [disabled]="!isCustomizingContentEditorTextChanged() || isTextEmpty()" (click)="saveCustomizingContentModal.show(); checkVariablesInContent()">Save</button>
        </div>
      </div>
    </div>
    <!-- END Customizing Content Editor -->
  </div>
  <!-- End Right Panel -->
</div>
  <!-- Confirm Save Modal -->
  <div class="modal fade" bsModal #saveCustomizingContentModal="bs-modal" [config]="{backdrop: 'static'}"
       tabindex="-1" role="dialog" aria-labelledby="saveCustomizingContentModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="saveCustomizingContentModalLabel">Confirm</h4>
          <button id="saveCustomizingContentModalHeaderClose" type="button" class="btn-close btn-close-white" data-dismiss="modal" aria-label="Close" (click)="saveCustomizingContentModal.hide()"></button>
        </div>
        <div class="modal-body">
          <p *ngIf="isDefaultContentSelected()" class="text-primary">WARNING: You are about to change the default template's content, which could be used by any locale and any product if a template is not explicitly defined for that locale and product.</p>
          <p *ngIf="!isDefaultContentSelected()" class="text-primary">Save changes?</p>
        </div>
        <div class="modal-footer">
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
              <button id="saveCustomizingContentModalFooterAccept" type="button" class="btn btn-primary w-100" data-dismiss="modal" (click)="checkNumberCharacters(); saveCustomizingContentModal.hide()">OK</button>
              <button id="saveCustomizingContentModalFooterCancel" type="button"  class="btn btn-default w-100" data-dismiss="modal" (click)="saveCustomizingContentModal.hide()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END Confirm Save Modal -->

  <!-- Confirm Discard Modal -->
  <div class="modal fade" bsModal #discardCustomizingContentModal="bs-modal" [config]="{backdrop: 'static'}"
       tabindex="-1" role="dialog" aria-labelledby="discardCustomizingContentModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="discardCustomizingContentModalLabel">Confirm</h4>
          <button id="discardCustomizingContentModalHeaderClose" type="button" class="btn-close btn-close-white" data-dismiss="modal" aria-label="Close" (click)="cancelNavToOtherCustomizedContent(); discardCustomizingContentModal.hide()"></button>
        </div>
        <div class="modal-body">
          <p class="text-primary">Discard changes?</p>
        </div>
        <div class="modal-footer">
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
              <button id="discardCustomizingContentModalFooterAccept" type="button" class="btn btn-primary w-100" data-dismiss="modal" (click)="discardCustomizedContent(); discardCustomizingContentModal.hide(); customizingContentEditorExpanded(navToTemplateDefinitionSel)">OK</button>
              <button id="discardCustomizingContentModalFooterCancel" type="button" class="btn btn-default w-100" data-dismiss="modal" (click)="cancelNavToOtherCustomizedContent(); discardCustomizingContentModal.hide()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END Confirm Discard Modal -->

  <!-- Confirm Revert Modal -->
  <div class="modal fade" bsModal #revertToDefaultContentModal="bs-modal" [config]="{backdrop: 'static'}"
       tabindex="-1" role="dialog" aria-labelledby="revertToDefaultContentModalLabel">
    <div class="modal-dialog " role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="revertToDefaultContentModalLabel">Confirm</h4>
          <button id="revertToDefaultContentModalHeaderClose" type="button" class="btn-close btn-close-white" data-dismiss="modal" aria-label="Close" (click)="revertToDefaultContentModal.hide()"></button>
        </div>
        <div class="modal-body">
          <p class="text-primary">Revert to default content?</p>
        </div>
        <div class="modal-footer">
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
              <button id="revertToDefaultContentModalFooterAccept" type="button" class="btn btn-primary w-100" data-dismiss="modal" (click)="revertToDefaultContent(); revertToDefaultContentModal.hide()">Accept</button>
              <button id="revertToDefaultContentModalFooterCancel" type="button" class="btn btn-default w-100" data-dismiss="modal" (click)="cancelRevertToDefaultContent(); revertToDefaultContentModal.hide()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END Confirm Revert Modal -->

  <!-- Preview Modal -->
  <div class="modal fade" bsModal #previewModal="bs-modal"  tabindex="-1" role="dialog"
    aria-labelledby="previewModalLabel" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="previewModalLabel">Preview</h4>
          <button id="previewModalHeaderClose" type="button" class="btn-close btn-close-white" data-dismiss="modal" aria-label="Close" (click)="previewModal.hide();"></button>
        </div>
        <div class="modal-body">
          <div class="card">
            <div id="previewHead" class="card-header">
              <h2 class="panel-title"
                  *ngIf="(templateWithContent.definitions | componentTypeFilter:componentTypeEnum.SUBJECT).length === 0">
                (No Subject)
              </h2>
              <h2 class="panel-title"
                  *ngFor="let templateDefinition of templateWithContent.definitions | componentTypeFilter:componentTypeEnum.SUBJECT"
                  [innerHTML]="getContentTextRendered(templateDefinition.templateComponent)"></h2>
            </div>
            <div id="previewBody" class="card-body">
              <span id="previewContent" [innerHTML]="( isShowingPilcrowsInPreview ? templatePreviewText.pilcrowedText : templatePreviewText.regularText ) | safeHTML"></span>
            </div>
          </div>
          <div class="row">
            <div [className]="(templateDeliveryPathSel?.code === deliveryPathEnum.VOICE ? 'col-xs-12 col-sm-4 col-md-4 mt-4 mb-4' : 'col-xs-12 col-sm-4 col-md-8 mt-4 mb-4')">
              <span id="previewModalSubjectCount" class="form-control-static text-body-secondary"
                    *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.EMAIL">
                Subject character count:
                <span class="badge">{{templatePreviewText.subjectCharCount}}</span>
                <br/>
              </span>
              <span id="previewModalTextCount" class="form-control-static text-body-secondary">
                <span
                  [innerText]="(templateDeliveryPathSel?.code === deliveryPathEnum.EMAIL?'Body c' : 'C') + 'haracter count:&nbsp;'"></span>
                <span class="badge">
                  {{templatePreviewText.bodyCharCount + (templateDeliveryPathSel?.code === deliveryPathEnum.SMS ? templatePreviewText.subjectCharCount : 0)}}
                </span>
                <br *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.EMAIL"/>
              </span>
              <span id="previewModalTotalCount" class="form-control-static text-body-secondary"
                    *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.EMAIL">
                Total character count:
                <span class="badge">{{templatePreviewText.bodyCharCount + templatePreviewText.subjectCharCount}}</span>
              </span>
            </div>

            <div *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.VOICE" class="col-xs-12 col-sm-5 col-md-5 mt-4 mb-4">
              <app-content-player
                id="previewContentPlayer"
                for="previewContent"
                controls="PlPgMt"
                (load)="previewContentPlyrLoadTts($event)"
                [download]="true">
              </app-content-player>
            </div>
            <div
              class="col-xs-12 col-sm-3 col-md-3 col-sm-offset-5 col-md-offset-5 mt-4 mb-4">
              <div class="btn-group" style="float:right;" role="group" aria-label="Buttons">
                <button id="previewTemplateShowPilcrow"
                        type="button"
                        [class]="'fa btn btn-' + (isShowingPilcrowsInPreview ? 'default' : 'primary')"
                        [tooltip]="!isShowingPilcrowsInPreview ? 'Show Pilcrow' : 'Hide Pilcrow'"
                        container="body"
                        (click)="switchTemplatePreviewShowPilcrow(); getPreviewTemplateText();">
                  &nbsp;&para;&nbsp;
                </button>
                <button id="previewModalSendPreview" type="button"
                        class="btn btn-primary"
                        tooltip="Send preview to my user"
                        container="body"
                        [disabled]="isRequestingSendPreview"
                        (click)="sendPreview()">
                  <i [class]="'fa ' + (isRequestingSendPreview?'fa-spinner fa-spin':'fa-paper-plane')"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div [className]="'col-xs-12 col-sm-12 col-md-12'">
              <span id="previewModalSubjectWarn" class="form-control-static text-body-secondary"
                    *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.EMAIL">
                <i style="color: #461E7D;" class="fas fa-lg fa-info-circle"></i>&nbsp;
                Subject supports up to 255 characters after replacing variables. If it exceeds this value, it may be truncated
                <br/>
              </span>
              <span id="previewModalTotalWarn" class="form-control-static text-body-secondary"
                    *ngIf="templateDeliveryPathSel?.code === deliveryPathEnum.EMAIL">
                <i style="color: #461E7D;" class="fas fa-lg fa-info-circle"></i>&nbsp;
                The total characters supported is 2500 after replacing variables, if message exceeds this value the notification may not be sent
              </span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button id="previewModalFooterClose" type="button" class="col-md-3 col-md-offset-6 text-right btn btn-default btn-sm"
                  data-dismiss="modal" (click)="previewModal.hide()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- END Preview Modal -->

  <!-- Shared Templates Modal -->
  <app-shared-templates-modal
    [templateComponent]="selectedTemplateComponent"
    [sharedTemplates]="sharedTemplatesForSelectedTemplateComponent"
    [templatesTotalCount]="templates?.length"
    (close)="onCloseSharedTemplatesModal()">
  </app-shared-templates-modal>
  <!-- END Shared Templates Modal -->

</form>
